<script>
/** 
this.dataBehavior = {
    state0:{
        selected: 'Transition_Normal_To_Hover' // Transition au hover
    },
    state0to1{
        selected: 'Transition_Hover_To_Selected', //Transtion de l'état final du hover (en state0) à l'état selected (en state1)
        notselected: 'Transition_Normal_To_NotSelected' //Transtion de l'état normal (en state0) à l'état notselected (en state1)
    },
    state1to0{
        selected: 'Transition_Selected_To_Normal', //Transition de l'état selected (en state1) à l'état normal (en state0)
        notselected: //normalement ça sera la meme animation que `state0to1.notselected` mais jouéer à l'enver
    }
    state1: {
        selected: 'Transition_NotSelected_to_Selected' //Transition de normal(/notselected) à l'état hover(/selected)
    }
}
*/

import Store from '@/stores/store.js'
import TweenMax from "gsap/TweenMax";
import GL from '@/views/GL/GL.js'
import FontVariableGL from '@/views/GL/FontVariableGL.js'
import Raf from '@/utils/raf.js'

export default {
    name: 'TextFontAnim',
    
    props: {
        text: String,
        top: { type: Number, default: 0},
        left: { type: Number, default: 0},
        letterSpacing: { type: Number, default: 0},
        fontSize: Number,
        behavior: Object,
        duration: { type: Number, default: 0.7},
        updateState: { type: Boolean, default: false},
        hover: { type: Boolean, default: true},
        lineHeight: { type: Number, default: 120},
        opacityDuration: { type: Number, default: 0.8},
        isDirector: { type: Boolean, default: false},
    },
    
    data() {
        return {
            tween: {
                progress: 0,
                color: null,
            },
            isHovered: false,
            reverse: false,
            isSelected: false,
            isActive: true,
            currentState: 0,
            isTransitionning: true,
            wasSelected: false,
            init: true,
        }
    },
    
    render(){
        return null;
    },

    created() {
        this.locked = false;
        this.tween.color = this.opacityText;
        this.tween.progress = this.startAnim;
        /**
         * Sets the transition of the element, one for desktop, the other for mobile 
         */
        if(Store.isDesktop) this.fontTransitions = Array.from(new Set([this.behavior.state0.hover, this.behavior.state0to1.selected, this.behavior.state0to1.notselected, this.behavior.state1to0.selected, this.behavior.state1.hover,this.behavior.state1.hoverselected,]));
        else this.fontTransitions = Array.from(new Set([this.behavior.mobile,]));
        this._updateColor = this.updateColor.bind(this);

        this.textGL = new FontVariableGL(
            this.text,
            this.fontTransitions,
            this.mouseEnter,
            this.mouseLeave,
            this.onClick,
            this.letterSpacing,
            this.lineHeight
        );

        this.setPosition();
        this.setFontsize();
        this.updateColor();


        GL.addTextGL(this.textGL);

        this.updateFontTransition(true);
        Raf.add(this.update);
    },


    methods:{
        update(){
            /**
             * Sets the progress of the animation
             */
            this.textGL.setProgress(this.tween.progress);
        },

        updateColor(){
            /**
             * Sets the color for unselected or selected elements
             */
            this.textGL.setColor(this.tween.color);
        },

        setPosition(){
            this.textGL.mesh.position.x = this.left;
            this.textGL.mesh.position.y = this.top;
        },

        setFontsize(){
            this.textGL.mesh.scale.setScalar(this.fontSize);
        },

        mouseEnter(){
            /**
             * Callback of the raycasting, handles cursor name & transition
             */
            Store.state.cursorText = this.cursorName()
            Store.state.cursorHover = false
            this.isHovered = true;
            // if locked or not hover & selected then dont animate
            if(this.locked || (!this.hover && this.isSelected) || !this.isActive) return;
            this.progressTween = TweenMax.to(this.tween, 0.6, {progress: this.endAnim, onUpdate: this.update, ease: Power4.easeOut });
        

        },

        mouseLeave(){
            Store.state.cursorText = ''
            Store.state.cursorHover = false
            this.isHovered = false;
            if(this.locked) return;
            this.progressTween = TweenMax.to(this.tween, 0.6, {progress: this.startAnim, onUpdate: this.update, ease: Power4.easeOut });
        },

        
        cursorName(){
            //helper function tu retrieve the cursor text depending on selected or not
            return this.isSelected ? 'Back' : '';
        },

        changeSelected(bool) {
            this.isSelected = bool;
        },

        setState(state) {
            this.currentState = state
        },

        updateFontState(immediate = true) {
            //used to update state fonts when going from selected to not selected 
            this.locked = true;
            if( this.currentState == 1 ){
                if(this.isSelected){
                    TweenMax.to(this.tween, immediate ? 0 : 0.3, {progress: this.endAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                        this.textGL.setTransition(this.behavior.state0to1.selected);
                        TweenMax.fromTo(this.tween, immediate ? 0 : this.duration, {progress: 1}, {progress: 0, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                            this.textGL.setTransition(this.behavior.state1.hoverselected);
                            this.locked = false;
                            this.tween.progress = 0;
                        }});
                    }})
                }else{
                    TweenMax.to(this.tween, immediate ? 0 : 0.3, {progress: this.startAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                        this.textGL.setTransition(this.behavior.state1.hoverselected);
                        TweenMax.fromTo(this.tween, immediate ? 0.4 : this.duration, {progress: 0}, {progress: 1, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                            this.textGL.setTransition(this.behavior.state1.hover);
                            this.locked = false;
                            this.tween.progress = 0;
                        }});
                    }})
                }
            }
        },

        updateFontTransition(immediate = false){
            if(Store.isDesktop) {
                this.locked = true;
                //Si l'on quitte le 1er niveau pour le 2eme
                if( this.currentState == 1 ){
                    if(this.isSelected){
                        TweenMax.to(this.tween, immediate ? 0 : 0.3, {progress: this.endAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                            this.textGL.setTransition(this.behavior.state0to1.selected);
                            TweenMax.fromTo(this.tween, immediate ? 0 : this.duration, {progress: 1}, {progress: 0, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                                this.textGL.setTransition(this.behavior.state1.hoverselected);
                                this.locked = false;
                                this.tween.progress = 0;
                            }});
                        }})
                    }else{
                        TweenMax.to(this.tween, immediate ? 0 : 0.3, {progress: this.startAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                            this.textGL.setTransition(this.behavior.state0to1.notselected);
                            TweenMax.fromTo(this.tween, immediate ? 0 : this.duration, {progress: 0}, {progress: 1, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                                this.textGL.setTransition(this.behavior.state1.hover);
                                this.locked = false;
                                this.tween.progress = 0;
                            }});
                        }})
                    }
                }

                //Si l'on quitte le 2eme niveau pour le 1er
                if( this.currentState == 0 ){
                    if(this.wasSelected){
                        TweenMax.to(this.tween, immediate ? 0 : 0.3, {progress: this.startAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                            this.textGL.setTransition(this.behavior.state1to0.selected);
                            TweenMax.fromTo(this.tween, immediate ? 0 : this.duration, {progress: 0}, {progress: 1, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                                this.textGL.setTransition(this.behavior.state0.hover);
                                this.tween.progress = 0;
                                this.locked = false;
                            }});
                        }})
                    }else{
                        TweenMax.to(this.tween, immediate ? 0 : 0.3, {progress: this.startAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                            this.textGL.setTransition(this.behavior.state0to1.notselected);
                            TweenMax.fromTo(this.tween, immediate ? 0 : this.duration, {progress: 1}, {progress: 0, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                                this.textGL.setTransition(this.behavior.state0.hover);
                                this.tween.progress = 0;
                                this.locked = false;
                            }});
                        }})
                    }
                }
            }
            else {
                this.textGL.setTransition(this.behavior.mobile);
            }

        },

        enterFontTransition(duration, immediate = false) {
            TweenMax.to(this.tween, immediate ? 0 : 0, {progress: this.startAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                this.textGL.setTransition(this.behavior.state1to0.notselected);
                TweenMax.fromTo(this.tween, immediate ? 0 : duration, {progress: 1}, {progress: 0, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                    this.textGL.setTransition(this.behavior.state0.hover);
                    this.tween.progress = 0;
                }});
            }})
        },

        leaveFontTransition(duration, immediate = false) {
            this.locked = true
            TweenMax.to(this.tween, immediate ? 0 : 0, {progress: this.startAnim, onUpdate: this.update, ease: Power2.easeIn, onCompleteScope: this, onComplete: function(){
                this.textGL.setTransition(this.behavior.state1to0.notselected);
                TweenMax.fromTo(this.tween, immediate ? 0 : duration, {progress: 0}, {progress: 1, onUpdate: this.update, ease: Power2.easeOut, onCompleteScope: this, onComplete: function(){
                    this.textGL.setTransition(this.behavior.state0.hover);
                    this.tween.progress = 0;
                    this.locked = false;
                }});
            }})
        }
    },

    computed: {
        startAnim: function(){
            return this.reverse ? 1 : 0;
        },
        endAnim: function(){
            return this.reverse ? 0 : 1;
        },
        opacityText:function(){
            if( this.currentState == 0){
                if (this.isDirector){
                    if( Store.state.cursorHover){
                        return this.isHovered ? 1 : 0.5;
                    }else{
                        return 1;
                    }
                }else{
                    return 1;
                }
            }else if (this.isSelected){
                return 1
            }else{
                return this.isHovered ? 1 : 0.5;
            }
        },
    },

    watch: {
        opacityText:  function(newVal, oldVal){
            if( this.isDirector ){
                TweenMax.to(this.tween, this.opacityDuration, { color: newVal, onUpdate: this._updateColor, ease: Power2.easeInOut });
            }else{
                TweenMax.to(this.tween, this.opacityDuration, { color: newVal, onUpdate: this._updateColor });
            }
        },

        isSelected: function(){
            if(this.updateState && !this.isTransitionning && !Store.isMobile) this.updateFontState();
            
            setTimeout(() => {
                this.wasSelected = this.isSelected
            }, 50);
        },

        currentState: function(newVal, oldVal){
            if(Store.state.init) {
                this.updateFontTransition(true);
                setTimeout(() => {
                    Store.state.init = false
                }, 100);
                
            } 
            else {
                this.updateFontTransition();
            }
            
            this.isTransitionning = !this.isTransitionning
        },

        fontSize: function(){
            this.setFontsize();
        },
        top: function(){
            this.setPosition()
        },
        left: function(){
            this.setPosition()
        },
    },
}
</script>
